import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { OpportunityWizardProvider } from './OpportunityWizardContext';
import Step1Customer from './Step1Customer';
import Step2Tenant from './Step2Tenant';
import Step3Contacts from './Step3Contacts';
import Step4Details from './Step4Details';
import Step5Plans from './Step5Plans';
import Step6Summary from './Step6Summary';
import Step7Proposal from './Step7Proposal';
import OpportunityConfirmation from './OpportunityConfirmation';

const OpportunityWizard = () => {
  return (
    <OpportunityWizardProvider>
      <Routes>
        <Route path="step1" element={<Step1Customer />} />
        <Route path="step2" element={<Step2Tenant />} />
        <Route path="step3" element={<Step3Contacts />} />
        <Route path="step4" element={<Step4Details />} />
        <Route path="step5" element={<Step5Plans />} />
        <Route path="step6" element={<Step6Summary />} />
        <Route path="step7" element={<Step7Proposal />} />
        <Route path="confirmation/:id" element={<OpportunityConfirmation />} />
        <Route path="*" element={<Navigate to="step1" replace />} />
      </Routes>
    </OpportunityWizardProvider>
  );
};

export default OpportunityWizard; 